module.exports = __webpack_public_path__ + "images/line_friend_lp/line-campaign-top-image_11ed2e49be8cfb666a7fcec5bf2ca807.png";